import { Stack, Typography } from '@mui/material'
import { FieldErrors, UseFormRegister } from 'react-hook-form'

import { useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'

import { SettingValues } from '../PersonalInfoForm'
import { TextInputCell } from './Common'

type AddressInputCellProps = {
  register: UseFormRegister<SettingValues>
  errors: FieldErrors<SettingValues>
  isRequired?: boolean
}

export const AddressInputCell: Cell<AddressInputCellProps> = ({
  register,
  errors,
  isRequired,
}) => {
  const { t } = useTranslation('personalInfoSettings')

  return (
    <CellFrame sx={{ pt: 6 }}>
      <Stack pb={4} direction="row" alignItems="center">
        <Typography variant="subtitle1" color="text.secondary">
          {t('shippingAddress', '住所（配送先）')}
        </Typography>
        {isRequired && (
          <Typography
            variant="caption"
            color="error.main"
            component="p"
            ml={1}
            mt={-1}
          >
            {t('required', '※必須')}
          </Typography>
        )}
      </Stack>
      <TextInputCell
        type="text"
        error={errors?.postalCode}
        {...register('postalCode')}
      />
      <TextInputCell
        type="text"
        error={errors?.prefecture}
        {...register('prefecture')}
      />
      <TextInputCell type="text" error={errors?.city} {...register('city')} />
      <TextInputCell type="text" error={errors?.line1} {...register('line1')} />
      <TextInputCell type="text" error={errors?.line2} {...register('line2')} />
    </CellFrame>
  )
}
